import { LineResultsRequester } from './line-results-requester.model';

export class Result {
  lineResultsRequesters: LineResultsRequester[];
  variablesEnvelop: string[];
  variablesTimeHistory: string[];
  staticEnvelopeIntervalInit: number;
  staticEnvelopeIntervalEnd: number;
  dynamicEnvelopeIntervalInit: number;
  dynamicEnvelopeIntervalEnd: number;

  constructor() {}
}
